import { Button } from '@components';
import { PageIndicatorProps } from 'types/pagination';

import theme from '../../../themes/colors';

const PreviousPageButton = ({ page, setPage }: PageIndicatorProps) => {
  const goToPrevious = () => {
    if (page > 1 && setPage) setPage(page - 1);
  };

  const isDisabled = page === 1;

  return (
    <Button
      label="Previous"
      disabled={isDisabled}
      handleClick={goToPrevious}
      variant="tertiary"
      size="medium"
      leftIconName="back-grey"
      labelStyle="!font-medium"
      leftIconStroke={isDisabled ? theme.grey : theme.content}
    />
  );
};

export default PreviousPageButton;
